// extracted by mini-css-extract-plugin
export var dropdown = "_vp-0";
export var imageWrapper = "_vp-3";
export var itemNameContainer = "_vp-1";
export var productImage = "_vp-2";
export var spinnerWrapper = "_vp-4";